/* ------------------------------------------------------------------
   Pink Rose — selettore variante nel carrello
   Ogni operazione (+ / - / cestino / cambio variante) passa da run():
   un lock impedisce che due operazioni si sovrappongano, causa dei
   doppioni quando si cliccava "+" e subito dopo si cambiava colore.
   ------------------------------------------------------------------ */
class CartVariantPicker {
  constructor() {
    this._busy = false;
    this.injectStyles();
    this.init();
  }

  injectStyles() {
    if (document.getElementById('pr-cart-busy-style')) return;
    const style = document.createElement('style');
    style.id = 'pr-cart-busy-style';
    style.textContent =
      '.pr-cart-busy{pointer-events:none;opacity:.55;transition:opacity .15s ease}' +
      '.pr-clear--confirm{color:#b3131b !important;font-weight:700 !important}';
    document.head.appendChild(style);
  }

  toggleBusy(on) {
    this._busy = !!on;
    document.querySelectorAll('cart-drawer-items, #main-cart-items').forEach((el) => {
      el.classList.toggle('pr-cart-busy', !!on);
    });
  }

  refreshDrawer() {
    if (typeof window.PRRefreshCartDrawer === 'function') {
      return window.PRRefreshCartDrawer();
    }
    window.location.reload();
    return Promise.resolve();
  }

  // Esegue una sola operazione per volta e ricarica il carrello alla fine.
  run(task, opts) {
    if (this._busy) return Promise.resolve();
    const options = opts || {};
    this.toggleBusy(true);

    return Promise.resolve()
      .then(task)
      .catch((err) => {
        console.error('Pink Rose — carrello:', err);
      })
      .then(() => {
        if (options.reload) {
          window.location.reload();
          return null;
        }
        return this.refreshDrawer();
      })
      .then(() => {
        this.toggleBusy(false);
      });
  }

  postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then((r) =>
      r.json().then((data) => {
        if (!r.ok) throw new Error(data.description || data.message || url + ' ' + r.status);
        return data;
      })
    );
  }

  getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
  }

  init() {
    // Riesegui quando il drawer si apre
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) {
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((m) => {
          if (m.type === 'attributes' && m.attributeName === 'class') {
            if (cartDrawer.classList.contains('active')) {
              setTimeout(() => this.updateAllPromoBanners(), 100);
            }
          }
        });
      });
      observer.observe(cartDrawer, { attributes: true });
    }

    document.addEventListener('change', (e) => {
      const select = e.target.closest('.cart-variant-picker__select');
      if (!select) return;
      const picker = select.closest('.cart-variant-picker');
      this.handleVariantChange(picker);
    });

    // Pulsante "-" del gruppo — toglie UNA unita', non tutta la riga.
    // Un bundle da 3 spesso e' una sola riga con quantity: 3: mettere
    // quantity 0 cancellava tutti e tre i pezzi in un colpo solo.
    document.addEventListener('click', (e) => {
      const minusBtn = e.target.closest('.cart-group__remove-last');
      if (!minusBtn) return;
      const key = minusBtn.dataset.key;
      const handle = minusBtn.dataset.handle;
      if (!key && !handle) return;
      this.run(() => this.decrementLine(key, handle));
    });

    // Pulsante "+" del gruppo — aggiunge una nuova riga
    document.addEventListener('click', (e) => {
      const plusBtn = e.target.closest('.cart-group__add');
      if (!plusBtn) return;
      const variantId = plusBtn.dataset.variantId;
      if (!variantId) return;

      this.run(() =>
        this.postJSON('/cart/add.js', {
          id: parseInt(variantId),
          quantity: 1,
          properties: { _line_id: Date.now().toString(36) + Math.random().toString(36).slice(2) }
        })
      );
    });

    // Bottone del riquadro promo — aggiunge le unita' che mancano alla soglia
    document.addEventListener('click', (e) => {
      const promoBtn = e.target.closest('[data-promo-btn]');
      if (!promoBtn) return;
      const variantId = promoBtn.dataset.variantId;
      const missing = parseInt(promoBtn.dataset.missing, 10) || 1;
      if (!variantId) return;

      this.run(() => {
        const calls = [];
        for (let i = 0; i < missing; i += 1) {
          calls.push(() =>
            this.postJSON('/cart/add.js', {
              id: parseInt(variantId),
              quantity: 1,
              properties: {
                _line_id: Date.now().toString(36) + Math.random().toString(36).slice(2) + i
              }
            })
          );
        }
        // In sequenza: /cart/add.js in parallelo perde delle righe.
        return calls.reduce((p, fn) => p.then(fn), Promise.resolve());
      });
    });

    // Cestino riga singola — usa key direttamente
    document.addEventListener('click', (e) => {
      const removeBtn = e.target.closest('.button--cart-item-remove');
      if (!removeBtn) return;

      const cartRemoveButton = removeBtn.closest('cart-remove-button');
      if (!cartRemoveButton) return;

      const key = cartRemoveButton.dataset.index;
      if (!key || !key.includes(':')) return; // solo se è una key, non un indice numerico

      e.preventDefault();
      e.stopImmediatePropagation();

      this.run(() => this.postJSON('/cart/change.js', { id: key, quantity: 0 }));
    });

    this.updateAllPromoBanners();
  }

  // Toglie UNA sola unita'. Se la riga ne ha 3 ne restano 2; se ne ha 1
  // la riga sparisce. Se la key non esiste piu' (drawer non aggiornato)
  // ripiega sull'ultima riga dello stesso prodotto, cosi' il click non
  // va perso e comunque non cancella mai piu' di un pezzo.
  decrementLine(lineKey, handle) {
    return this.getCart().then((cart) => {
      const items = cart.items || [];
      let target = items.find((i) => i.key === lineKey);

      if (!target && handle) {
        const same = items.filter((i) => i.handle === handle);
        target = same[same.length - 1];
      }
      if (!target) return null;

      const nextQty = Math.max(0, (target.quantity || 1) - 1);
      return this.postJSON('/cart/change.js', { id: target.key, quantity: nextQty });
    });
  }

  updateAllPromoBanners() {
    const dataEl = document.getElementById('cart-promo-data');
    if (!dataEl) return;

    let promoData = {};
    try {
      promoData = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }

    document.querySelectorAll('.cart-group__promo').forEach((banner) => {
      const handle = banner.dataset.handle;
      const data = promoData[handle];
      if (!data) return;

      let thresholds = [];
      try {
        thresholds = (typeof data === 'string' ? JSON.parse(data) : data).thresholds || [];
      } catch (e) {
        return;
      }

      // Conta i PEZZI, non le righe: un bundle da 3 e' una riga sola.
      const headerRow = document.getElementById('CartGroup-' + handle);
      const countEl = headerRow ? headerRow.querySelector('.cart-group__count') : null;
      const currentQty = countEl ? parseInt(countEl.textContent, 10) || 0 : 0;

      const next = thresholds.filter((t) => t.qty > currentQty).sort((a, b) => a.qty - b.qty)[0];
      if (next && next.qty) {
        banner.dataset.upsellQty = next.qty;
        if (next.savings) banner.dataset.upsellSavings = next.savings;
      }
    });

    if (typeof window.PRApplyCartPromo === 'function') window.PRApplyCartPromo();
  }

  handleVariantChange(picker) {
    if (this._busy || !picker) return;

    const selects = picker.querySelectorAll('.cart-variant-picker__select');
    if (!selects.length) return;

    const productHandle = selects[0].dataset.productHandle;
    const lineKey = selects[0].dataset.lineKey;
    const context = picker.dataset.context;
    const lineIndex = picker.dataset.lineIndex;

    const qtyInput = document.querySelector(
      context === 'drawer' ? `#Drawer-quantity-${lineIndex}` : `#Quantity-${lineIndex}`
    );
    const currentQuantity = qtyInput ? parseInt(qtyInput.value) : 1;
    const selectedOptions = Array.from(selects).map((s) => s.value);
    const lineProperties = JSON.parse(picker.dataset.lineProperties || '{}') || {};

    fetch(`/products/${productHandle}.js`)
      .then((r) => r.json())
      .then((product) => {
        const variant = this.findVariant(product.variants, selectedOptions);
        const unavailableMsg = picker.querySelector('.cart-variant-picker__unavailable');

        if (!variant || !variant.available) {
          if (unavailableMsg) unavailableMsg.style.display = 'block';
          return;
        }
        if (unavailableMsg) unavailableMsg.style.display = 'none';

        if (variant.id === parseInt(selects[0].dataset.currentVariantId)) return;

        const previewImg = picker.querySelector('.cart-variant-picker__preview-img');
        if (previewImg && variant.featured_image && variant.featured_image.url) {
          previewImg.src = variant.featured_image.url.replace(/(\.\w+)$/, '_80x80$1');
        }

        this.run(() => this.swapVariant(lineKey, variant.id, currentQuantity, lineProperties), {
          reload: context !== 'drawer'
        });
      })
      .catch((err) => console.error('Pink Rose — variante:', err));
  }

  // Rimuove la riga e SOLO se e' sparita davvero aggiunge la nuova variante.
  // Senza questa verifica un remove fallito (key scaduta) produceva un doppione.
  swapVariant(lineKey, newVariantId, quantity, lineProperties) {
    return this.postJSON('/cart/change.js', { id: lineKey, quantity: 0 })
      .then((cart) => {
        const stillThere = (cart.items || []).some((i) => i.key === lineKey);
        if (stillThere) {
          throw new Error('riga non rimossa, aggiunta annullata per non creare doppioni');
        }
        const properties = Object.assign({}, lineProperties);
        properties._line_id = Date.now().toString(36) + Math.random().toString(36).slice(2);
        return this.postJSON('/cart/add.js', {
          id: newVariantId,
          quantity: quantity || 1,
          properties: properties
        });
      });
  }

  findVariant(variants, selectedOptions) {
    return variants.find((v) => v.options.every((opt, i) => opt === selectedOptions[i]));
  }
}

document.addEventListener('DOMContentLoaded', () => {
  if (!window.prCartVariantPicker) {
    window.prCartVariantPicker = new CartVariantPicker();
  }
});
